// Turning a thrown thing into a sentence someone can act on.
//
// This exists because of one message: `TypeError: Failed to fetch`. That is
// what the browser throws when a request never reached the server at all — a
// dropped connection, Wi-Fi changing over, a blocking extension — and it was
// being shown verbatim under the Create invoice button, where it reads as
// "the app is broken" rather than "try that again". Supabase's own errors are
// already written in plain language and are passed through untouched.

const NETWORK_FAILURE = /failed to fetch|networkerror|network request failed|load failed/i;

export function isNetworkError(err) {
  return NETWORK_FAILURE.test(err?.message || '');
}

// `retryLabel` is the button to press again — the words actually on it, so
// the message points at something visible on screen.
export function describeError(err, retryLabel = 'Save') {
  if (isNetworkError(err)) {
    return `Couldn't reach the server, so nothing was saved — the connection dropped before the request arrived. Check you're online, then press ${retryLabel} again.`;
  }
  return err?.message || String(err);
}
